module.exports = __webpack_public_path__ + "img/HiiL_logo.e84896de.png";